import { QueryKeys } from '../../utils/queryKeys';

export const postModuleFeedbackQuestionsKeys = {
    all: [QueryKeys.GET_POST_MODULE_FEEDBACK_FORM],
    getPostModuleFeedBackQuestions: () => [...postModuleFeedbackQuestionsKeys.all],
};